import React from 'react'
import './contentTerms.scss'
import Title from '../../atoms/title/title'
import { terms } from '../../../constants/activity-constants'

const ContentTerms = () => {
  return (
    <section className='f-terms'>
      <div className='f-terms__wrapper'>
        <div className='f-terms__title'>
          <Title
            color='purple'
            txt={['Términos y', 'condiciones']}
          />
        </div>

        <div className='f-terms__content'>
          <ul>
            {terms().map((item, index) => {
              return (
                <li><span>{index + 1}.</span> {item}</li>
              )
            })}
          </ul>

        </div>
      </div>
    </section>
  )
}

export default ContentTerms
